import { computed, defineComponent, onMounted, ref, toRefs, watch } from "@vue/composition-api";
import { Field, TextSection } from "@Shared/components/sections/index";
import CommissionDetailsTable from "./commission-details-table.vue";
import AddParticipantModal from "./add-participant-modal.vue";
import * as LenderSubmitGetters from "@Broker/@Modules/clients/applications/application/store/lender-submit-getters";
import * as LenderSubmitActions from "@Broker/@Modules/clients/applications/application/store/lender-submit-actions";
import { useApplicationStoreGetters, useApplicationStoreActions } from "@Broker/@Modules/clients/applications/application/store/application-helpers";
import CommissionDetailsLoader from "./commission-details-loader.vue";
export default defineComponent({
  name: "CommissionDetailsContainer",
  components: {
    Field,
    TextSection,
    CommissionDetailsTable,
    AddParticipantModal,
    CommissionDetailsLoader
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    agentUsername: {
      type: String,
      required: true
    },
    mortgageType: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: true
    },
    isReadOnly: {
      type: Boolean,
      required: true
    }
  },
  setup(props, {
    emit
  }) {
    const addingNewParticipant = ref(false);
    const defaultAgent = ref();
    const addParticipantModal = ref();
    const {
      applicationId,
      clientUsername,
      mortgageType
    } = toRefs(props);
    const {
      LOAD_COMMISSIONS_DETAILS,
      ADD_COMMISSIONS_DETAILS_PARTICIPANT,
      UPDATE_COMMISSIONS_DETAILS
    } = useApplicationStoreActions([LenderSubmitActions.LOAD_COMMISSIONS_DETAILS, LenderSubmitActions.ADD_COMMISSIONS_DETAILS_PARTICIPANT, LenderSubmitActions.UPDATE_COMMISSIONS_DETAILS]);
    const {
      GET_COMMISSION_DEDUCTIONS_TOTAL,
      GET_COMMISSION_DETAILS_PARTICIPANTS,
      GET_COMMISSION_DETAILS_SPLIT_TYPE,
      CURRENT_COMMISSIONS_FEES_TOTAL
    } = useApplicationStoreGetters([LenderSubmitGetters.GET_COMMISSION_DEDUCTIONS_TOTAL, LenderSubmitGetters.GET_COMMISSION_DETAILS_PARTICIPANTS, LenderSubmitGetters.GET_COMMISSION_DETAILS_SPLIT_TYPE, LenderSubmitGetters.CURRENT_COMMISSIONS_FEES_TOTAL]);
    onMounted(() => {
      loadCommissionsDetails();
    });
    watch(mortgageType, () => {
      loadCommissionsDetails();
    });
    const splitType = computed(() => GET_COMMISSION_DETAILS_SPLIT_TYPE.value(applicationId.value));
    const isBeforeSplit = computed(() => splitType.value === "before");
    const totalNetFees = computed(() => {
      return isBeforeSplit.value ? CURRENT_COMMISSIONS_FEES_TOTAL.value - totalCommissionDeduction.value : CURRENT_COMMISSIONS_FEES_TOTAL.value;
    });
    const afterSplitDeduction = computed(() => isBeforeSplit.value ? 0 : totalCommissionDeduction.value);
    const totalCommissionDeduction = computed(() => {
      return GET_COMMISSION_DEDUCTIONS_TOTAL.value(applicationId.value);
    });
    const participants = computed(() => {
      return GET_COMMISSION_DETAILS_PARTICIPANTS.value(applicationId.value);
    });
    const changeSplitType = type => {
      UPDATE_COMMISSIONS_DETAILS({
        applicationId: applicationId.value,
        commissionsDetails: {
          splitType: type
        },
        clientUsername: clientUsername.value,
        mortgageType: mortgageType.value
      });
    };
    const handleAddParticipant = async ({
      selectedParticipant
    }) => {
      await ADD_COMMISSIONS_DETAILS_PARTICIPANT({
        applicationId: applicationId.value,
        clientUsername: clientUsername.value,
        mortgageType: mortgageType.value,
        participant: selectedParticipant
      });
    };
    const showAddParticipantModal = () => {
      var _addParticipantModal$;
      return (_addParticipantModal$ = addParticipantModal.value) == null ? void 0 : _addParticipantModal$.openModal();
    };
    const loadCommissionsDetails = async () => {
      await LOAD_COMMISSIONS_DETAILS({
        applicationId: applicationId.value,
        clientUsername: clientUsername.value,
        mortgageType: mortgageType.value
      });
      emit("update:loading", false);
    };
    return {
      splitType,
      addingNewParticipant,
      defaultAgent,
      participants,
      totalNetFees,
      isBeforeSplit,
      addParticipantModal,
      totalCommissionDeduction,
      afterSplitDeduction,
      changeSplitType,
      handleAddParticipant,
      showAddParticipantModal,
      loadCommissionsDetails
    };
  }
});